module.exports = __webpack_public_path__ + "static/media/undraw_online_re_x00h-min.179260b6.png";